import { render, staticRenderFns } from "./Valores.vue?vue&type=template&id=bf4ae42c&scoped=true&"
import script from "./Valores.vue?vue&type=script&lang=js&"
export * from "./Valores.vue?vue&type=script&lang=js&"
import style0 from "./Valores.vue?vue&type=style&index=0&id=bf4ae42c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4ae42c",
  null
  
)

export default component.exports